
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";

interface LessonsGridErrorProps {
  onBack: () => void;
  pathId: string;
  error?: Error | null;
}

/**
 * LessonsGridError component - displays error state when lessons fail to load
 * Shows helpful error message with back navigation option
 */
export const LessonsGridError = ({ onBack, pathId, error }: LessonsGridErrorProps) => {
  console.error("💥 Error in lessons query:", error);
  
  return (
    <div className="space-y-8 animate-fade-in">
      <div className="flex items-center gap-4 px-8">
        <Button
          variant="ghost"
          onClick={onBack}
          className="group hover:bg-gray-100 -ml-2"
        >
          <ArrowLeft className="h-5 w-5 mr-2 group-hover:-translate-x-1 transition-transform duration-200" />
          Back to Module
        </Button>
      </div>

      <div className="text-center max-w-md mx-auto px-8">
        <div className="mb-6">
          <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <svg className="w-8 h-8 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
          <h2 className="text-2xl font-bold mb-2">Error Loading Lessons</h2>
          <p className="text-gray-600 mb-4">
            Failed to load lessons for this module. Please try refreshing the page.
          </p>
          <p className="text-sm text-gray-500">
            Module ID: {pathId}
          </p>
        </div>
      </div>
    </div>
  );
};
